import { useEffect } from "react";
import { CSSTransition } from "react-transition-group";

import LanguageSwitch from "@/components/LanguageSwitch";
import useRemoveScrollBar from "@/hooks/useRemoveScrollBar";
import { isWebshopClosed } from "@/utils/helpers";

import { AccessMenu } from "./AccessMenu";
import { NavigationLinks } from "./Navigation";
import sidebar from "./sidebar.module.css";

export const SidebarMenu = ({ isOpen = false }) => {
  const { removeScrollBar, reinstateScrollBar } = useRemoveScrollBar();

  useEffect(() => {
    isOpen ? removeScrollBar() : reinstateScrollBar();
  }, [isOpen]);

  return (
    <CSSTransition
      in={isOpen}
      unmountOnExit
      classNames={{
        enter: sidebar.enter,
        enterActive: sidebar.enterActive,
        exit: sidebar.exit,
        exitActive: sidebar.exitActive,
      }}
      addEndListener={(node, done) => {
        node.addEventListener("transitionend", done, false);
      }}
    >
      <nav className={sidebar.menu}>
        <NavigationLinks menu />
        {isWebshopClosed ? null : <AccessMenu menu />}
        <LanguageSwitch className={sidebar.switch} />
      </nav>
    </CSSTransition>
  );
};
